import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { invalidateTimesheetRowsQuery } from './query';
export const useInvalidateGetTimesheetRows = () => {
    const client = useQueryClient();
    return useCallback((id) => invalidateTimesheetRowsQuery(client, id), [client]);
};
//# sourceMappingURL=use-query.js.map